import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemPurpleFlowers extends Item {
    constructor() {
        super(definitions.ITEM_ID.PURPLE_FLOWERS, texture("prop_purple_flowers_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}